import { BrowserRouter, Route, Routes } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import About from "Parts/About";
import BottomMenu from "Parts/BottomMenu";
import Contact from "Parts/Contact";
import Header from "Parts/Header";
import Home from "Parts/Home";
import Portfolio from "Parts/Portfolio";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <BottomMenu />
      </BrowserRouter>
    </div>
  );
}
